import { FaWhatsapp, FaXmark } from "react-icons/fa6";
import { IoMdWarning } from "react-icons/io";

export const ModalWraperConfirmDelete = ({ isOpen, setIsOpen, message, children }) => {
    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            style={{
                background: "rgba(0, 0, 0, 0.7)",
                backdropFilter: "blur(4px)",
            }}
            onClick={() => setIsOpen(false)}
        >
            <div
                className="w-full max-w-lg rounded-2xl overflow-hidden shadow-2xl transition-all duration-300 transform scale-100"
                style={{
                    background: "rgba(15, 23, 42, 0.95)",
                    border: "1px solid rgba(51, 65, 85, 0.4)",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="px-3 flex flex-col items-center justify-center gap-3 pt-10">
                    <IoMdWarning className="text-red-300 text-7xl" />
                    <p className=" font-bold text-red-300 flex items-center gap-2">
                        {message ?? "Apakah anda yakin ingin menghapus data ini?"}
                    </p>
                </div>

                {/* Body Modal */}
                <div className="p-6">{children}</div>
            </div>
        </div>
    );
};